module.exports = __webpack_public_path__ + "img/solution11.6bd9d65c.png";